import React, {useState} from 'react';
import {Card, Row} from 'antd';
import {EyeInvisibleOutlined, EyeTwoTone} from '@ant-design/icons';
import InputComponent from '../../../atoms/Inputs/Input';
import AuthDialog from '../../../organisms/Forms/auth/component';
import styles from './style.module.css';
import {useIsMobile} from "../../../../utils/helpers";

interface FormProps {
    email: string;
    onEmailChange: (value: string) => void;
    password: string;
    required: boolean;
    onPasswordChange: (value: string) => void;
    onSubmit: (event: React.FormEvent) => Promise<void>;
    onOpenDialog: (mode: string) => void;
    onClose: () => void;
}


const LoginForm: React.FC<FormProps> = (
    {onClose, email, onEmailChange, password, onPasswordChange, required, onOpenDialog}) => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [showAuthDialog, setShowAuthDialog] = useState<string | null>(null);

    const isMobile = useIsMobile();

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const handleResetPassword = () => {
        onOpenDialog('reset');
    };

    const handleAuthDialogClose = () => {
        setShowAuthDialog(null);
    };
    const handleShowRegistration = () => {
        onClose();
        onOpenDialog('registration');
    };

    return (
        <Card title={<span style={{color: '#1677ff', fontWeight: 'bold', fontSize: '30px'}}>Log in</span>}>
            <form className={styles.loginForm}>
                <div>
                    <InputComponent
                        label={'Email or username'} value={email} placeholder={''} type={'email'}
                        labelPosition={'up'} required={required} onChange={onEmailChange}
                    />
                </div>
                <div style={{position: 'relative', marginBottom: '20px'}}>
                    <InputComponent
                        label={'Password'} value={password} placeholder={''} onChange={onPasswordChange}
                        type={passwordVisible ? 'text' : 'password'} labelPosition={'up'} required={required}
                    />
                    <button
                        type="button" onClick={togglePasswordVisibility}
                        style={{
                            position: 'absolute', right: '10px', top: '40%', transform: 'translateY(-50%)',
                            cursor: 'pointer', background: 'none', border: 'none', color: '#1677ff'
                        }}
                    >
                        {passwordVisible ? <EyeInvisibleOutlined/> : <EyeTwoTone/>}
                    </button>
                    <a style={{
                        color: '#1677ff',
                        fontSize: '10px',
                        display: 'inline-block',
                        marginTop: 8,
                        cursor: 'pointer'
                    }}
                       onClick={handleResetPassword}>Forgot password?
                    </a>
                </div>
                <Row justify={isMobile ? 'center' : 'end'}>
                  <span style={{color: 'grey', fontSize: isMobile ? '10px' : '14px'}}>
                    Don&#39;t have a Promotify account?{' '}
                      <a onClick={handleShowRegistration} style={{color: '#1677ff'}}>Sign up</a>
                  </span>
                </Row>
            </form>
            {showAuthDialog && (
                <AuthDialog type={'registration'} onClose={handleAuthDialogClose} onOpenDialog={onOpenDialog}/>
            )}
        </Card>
    );
};

export default LoginForm;